import { ChangeDetectorRef, Component, Injector, Input, OnDestroy, OnInit, Renderer2 } from '@angular/core';
import { SafeHtmlPipe } from '../safe-html-pipe/safe-html-pipe.component';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { ComponentBase } from '../component-base';
import { UtilService } from 'src/app/services/util.service';
import { UsuarioDaoService } from 'src/app/dao/usuario-dao.service';
import { LookupService } from 'src/app/services/lookup.service';
import { AuthService } from 'src/app/services/auth.service';
import { ConsoleLogger } from '@angular/compiler-cli';


@Component({
  selector: 'text-html',
  templateUrl: './text-html.component.html',
  styleUrls: ['./text-html.component.scss']
})
export class TextHtmlComponent extends ComponentBase implements OnDestroy {
  @Input() class?: string = '';
  @Input() analiser?: (element: HTMLElement, renderer: Renderer2, unlisteners: (() => void)[]) => void;
  @Input() set html(value: string | undefined) {
    if(this._html != value) {
      this._html = value;
      this.unregisterListiners();
      //@ts-ignore
      let newString = (value || "").replaceAll(/<a(\s.+?)>/g, '<a$1 target="_blank" style="font-size:12px;">').trim();
      this.sanitized = this.sanitizer.bypassSecurityTrustHtml(newString);
      this.detectChanges();
      if(this.viewInit && this.analiser) this.analiser($("#" + this.generatedId())[0], this.renderer, this.unlisteners);
    }
    let position = this._html?.search("data-user=");
    let position2 = this._html?.indexOf('"',position);
    position2!++;
    let position3 = position2! + 36;
    let id1 = this._html?.substring(position2!,position3!)
    this.id = id1;
    //console.log(position2, position3, this.id)
  }
  get html(): string | undefined {
    return this._html;
  }
  
  public sanitized: SafeHtml = "";
  public renderer: Renderer2; 
  public sanitizer: DomSanitizer;
  public utilService: UtilService;
  public randomId: string;
  public unlisteners: (() => void)[] = [];
  public usuarioDAO:UsuarioDaoService;
  public usuario:any;
  public loading:boolean = false;
  public lookup: LookupService;
  public id:any='';

  private _html?: string;

  constructor(public injector: Injector) {
    super(injector);
    this.utilService = injector.get<UtilService>(UtilService);
    this.sanitizer = injector.get<DomSanitizer>(DomSanitizer);
    this.renderer = injector.get<Renderer2>(Renderer2);
    this.usuarioDAO = injector.get<UsuarioDaoService>(UsuarioDaoService);
    this.lookup = injector.get<LookupService>(LookupService);
    this.randomId = this.utilService.md5();
  }

  public unregisterListiners() {
    let listener: (() => void) | undefined = undefined;
    while(listener = this.unlisteners.pop()) listener();
  }

  ngAfterViewInit(): void {
    if(this.analiser) this.analiser($("#" + this.generatedId(this.randomId))[0], this.renderer, this.unlisteners);
   //this.user()
  }

  ngOnDestroy(): void {
    this.unregisterListiners();
  }

  public user(){
    const spans = document.querySelectorAll(".spanID[data-user]");
    spans.forEach((span, index) => {
      const id = span.getAttribute('data-user')
        this.usuarioDAO?.getById(id!,[]).then(user => {
          this.usuario = user;
        }).finally(() => {
          this.cdRef.detectChanges();
        });
      });
  }
  
}